import React from 'react';
import styled from 'styled-components';
import Loading from '@catalogo/ui-americanas-mobile-loading';
import UserIcon from '@catalogo/ui-americanas-desktop-svg/user-red.svg';
import Rec from './rec';

const Logged = ({ name, hasRecommendations, loading, recs, pageType }) => {
  if (loading) {
    return <Loading />;
  }
  return (
    <Wrapper>
      <TopArea>
        <UserIcon width="45px" height="45px" />
        <UserArea>
          <Text>Olá, {name}</Text>
          <UserLinks>
            <Links>
              <Link href="https://minhaconta.americanas.com.br/v2/orders">meus pedidos</Link>
            </Links>
            <Links>
              <Link href="https://minhaconta.americanas.com.br/v2/">minha conta</Link>
            </Links>
            <Links>
              <Link href="https://www.americanas.com.br/listas/favoritos">favoritos</Link>
            </Links>
          </UserLinks>
        </UserArea>
      </TopArea>
      <RecsArea>
        {Object.keys(recs).map(recKey => (
          <Rec
            title={recs[recKey].title}
            products={recs[recKey].products}
            key={recKey}
            position={recKey}
            pageType={pageType}
            hasRecommendations={hasRecommendations}
          />
        ))}
      </RecsArea>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: 100%;
  width: 99%;
  border-radius: 4px;
  background: ${({ theme }) => theme.white};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.12);
  border-left: 10px solid ${({ theme }) => theme.primaryColor};
  display: flex;
  flex-direction: column;
  padding: 15px 0 0 15px;
  overflow: hidden;
`;

const TopArea = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 15px;
`;

const UserArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Text = styled.span`
  font-size: 21px;
  font-weight: bold;
  margin: 0 0 3px 10px;
  color: ${({ theme }) => theme.grey.darker};
`;

const UserLinks = styled.ul`
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`;

const Links = styled.li`
  margin-left: 15px;
  width: 90px;
  @media screen and (max-width: 375px) {
    margin-left: 7px;
  }
`;

const Link = styled.a`
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
`;

const RecsArea = styled.div`
  display: flex;
  flex-direction: row;
  padding: 20px 0;
  height: auto;
  overflow-x: scroll;
  overflow-y: hidden;
  &::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
`;

export default Logged;
